import AuthService from '../services/auth.service';
import HTTP from '../services/axios';
import bus from '@/plugins/eventBus';

const auth = {
  namespaced: true,

  state: {
    user: null,
    token: null,
    renewToken: localStorage.getItem('mbrt'),
    userActivated: null,
    expiresIn: null,
  },

  mutations: {
    LOGIN(state, payload) {
      state.user = payload.user;
      state.token = payload.token;
      state.expiresIn = payload.expiresIn;
      state.renewToken = payload.renewToken;
      state.userActivated = payload.userActivated;
      localStorage.setItem('mbrt', payload.renewToken);
      localStorage.setItem('mblogin', '1');
    },
    LOGOUT(state) {
      localStorage.removeItem('mbrt');
      localStorage.removeItem('mbcpid');
      state.renewToken = null;
      state.token = null;
      state.expiresIn = null;
      state.userActivated = null;
      localStorage.setItem('mblogin', '0');
    },
    UPDATE_USER(state, payload) {
      state.user = payload;
    },
    UPDATE_USER_ACTIVATED(state, vl) {
      state.userActivated = vl;
    },
    RENEW(state, payload) {
      state.user = payload.user;
      state.token = payload.token;
      state.expiresIn = payload.expiresIn;
      state.renewToken = payload.renewToken;
      localStorage.setItem('mbrt', payload.renewToken);
    },
  },

  actions: {
    login({ commit, state }, credentials) {
      return AuthService.login(credentials).then((resp) => {
        HTTP.interceptors.request.use((config) => {
          const cfg = config;
          cfg.headers.token = state.token;
          return cfg;
        });

        commit('LOGIN', resp);
        bus.$emit('login', resp.expiresIn);

        return resp.user;
      });
    },
    recoverPassword(_, phoneOrEmail) {
      return AuthService.recoverPassword(phoneOrEmail);
    },
    logout({ commit }) {
      commit('LOGOUT');
    },
    updateUser({ commit }, user) {
      commit('UPDATE_USER', user);
    },
    renew({ commit, state }) {
      if (!state.renewToken) {
        return null;
      }

      return AuthService.renew(state.renewToken).then((resp) => {
        HTTP.interceptors.request.use((config) => {
          const cfg = config;
          cfg.headers.token = state.token;
          return cfg;
        });

        commit('RENEW', resp);
        bus.$emit('renew', resp.expiresIn);
      });
    },
    updateUserActivated({ commit }, vl) {
      commit('UPDATE_USER_ACTIVATED', vl);
    },
  },

  getters: {
    getUser(state) {
      return state.user;
    },
    isAuthenticated(state) {
      return !!state.token;
    },
    isUserActivated(state) {
      return state.userActivated;
    },
  },
};

export default auth;
